import {
  RESET_PENDING_ORDER,
  SET_PENDING_ORDER,
  UPDATE_ADDRES_IS_LOADED,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_ATTRIBUTE,
  UPDATE_PENDING_ORDER,
} from '../actions/types';

const INITIAL_STATE = {};

export default (state: any = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PENDING_ORDER:
      return { ...state, ...action.payload };
    case SET_PENDING_ORDER:
      return action.payload;
    case RESET_PENDING_ORDER:
      return { shopId: null, address: null, commande: {} };
    case UPDATE_ADDRESS:
      return {
        ...state,
        address: action.payload.address,
        addressIsLoaded: true,
      };
    case UPDATE_ADDRESS_ATTRIBUTE:
      return {
        ...state,
        address: {
          ...state.address,
          [action.payload.attribute]: action.payload.value,
        },
      };
    case UPDATE_ADDRES_IS_LOADED:
      return { ...state, addressIsLoaded: action.payload };
    default:
      return state;
  }
};
